"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_METRICS = void 0;
exports.EMPTY_METRICS = {
    droppedFrames: 0,
    totalDownloadedBytes: 0,
    totalPausedTime: 0,
    totalPlayingTime: 0,
    totalSeekingTime: 0,
    totalWaitingTime: 0,
};
//# sourceMappingURL=IMetrics.js.map